export function buildBookedRecord(state, charge) {
    if (!state.selectedSlot)
        return null;
    return {
        slot: state.selectedSlot,
        date: state.selectedDate,
        timezone: state.selectedTimezone,
        mode: state.consultationMode,
        charge,
    };
}
export function buildBookedAppointment(state, payload) {
    return buildBookedRecord(state, bookedChargeOf(payload, state.selectedPack?.packageName ?? null));
}
function bookedChargeOf(payload, packName) {
    if (payload.bookingType === "USE_ACTIVE_PACKAGE") {
        return { kind: "ACTIVE_PACK" };
    }
    const charged = Number(payload.consultationCharge ?? 0);
    const amount = Number.isFinite(charged) ? charged : 0;
    const currency = payload.currency ?? "";
    if (payload.bookingType === "PACKAGE_PURCHASE") {
        return { kind: "PACK_PURCHASE", amount, currency, packName };
    }
    if (payload.followUp) {
        return { kind: "FOLLOW_UP", amount, currency };
    }
    return { kind: "CONSULTATION", amount, currency };
}
export function queueVisitCharge(quote, visit) {
    const billed = Number(visit?.finalAmount);
    const quotedCurrency = quote && quote.kind !== "ACTIVE_PACK" ? quote.currency : "";
    if (visit?.finalAmount != null && Number.isFinite(billed)) {
        return {
            kind: "CONSULTATION",
            amount: billed,
            currency: typeof visit.currency === "string" && visit.currency
                ? visit.currency
                : quotedCurrency,
        };
    }
    return quote;
}
export function bookedChargeAmount(charge) {
    return charge.kind === "ACTIVE_PACK" ? 0 : charge.amount;
}
